function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 5a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1zM15 26a1 1 0 100 2h2a1 1 0 100-2h-2zM17.948 14.746l1.892-.152c.133-.01.211.141.122.237l-6.6 7.12c-.1.109-.285.02-.256-.121l1.104-5.407c.018-.093-.06-.177-.158-.17l-1.892.152c-.133.011-.211-.14-.122-.236l6.601-7.121c.1-.108.284-.02.255.122l-1.103 5.408c-.02.092.059.177.157.168z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 1a3 3 0 00-3 3v24a3 3 0 003 3h12a3 3 0 003-3V4a3 3 0 00-3-3H10zM9 4a1 1 0 011-1h12a1 1 0 011 1v24a1 1 0 01-1 1H10a1 1 0 01-1-1V4z",
  fill: "currentColor"
})));